import React from 'react';
import ActivityCard from '../ActivityCard/ActivityCard';
import PortalCard from '../PortalCard/PortalCard';

export default function Home() {
  return (
    <>
      <PortalCard />
      <ActivityCard />
    </>
  );
}
